const C = require("../constants");
const initial_data = {open: false, client:{id:null, full_name:''}};

function ClientDialogReducer(state = initial_data, action) {
    switch (action.type) {
        case C.CLIENT_DIALOG:
            return action.data;
        default:
            return state;
    }
}

export default ClientDialogReducer;


// WEBPACK FOOTER //
// ./src/reducers/ClientDialogReducer.js